const SHOW_MODAL = 'modal/SHOW_MODAL';
const HIDE_MODAL = 'modal/HIDE_MODAL';

export default {
  SHOW_MODAL,
  HIDE_MODAL
};